import * as Models from "../../ts/rlAdmin.models";
import * as Consts from "../../ts/rlAdmin.consts";
import * as Utils from "../../ts/rlAdmin.utils";
import { BaseContractController } from "../_baseDealController";
import * as angular from "angular";
import { EntityService } from "../../services/entity-service";
import { ContractService } from "../../services/contract-service";
import { ContractSharedDataService } from "../../services/contract-shared-data-service";
import { LocalCacheService } from "../../services/local-cache-service";
import { NotifyService } from "../../services/notify-service";
import { EventService } from "../../services/event-service";
import { UsageService } from "../../services/usage-service";
import { AdminService } from "../../services/admin-service";
import { AssetService } from "../../services/asset-service";
import { AclService } from "../../services/acl-service";
import { SearchService } from "../../services/search-service";


export class ContractSummaryAssetsController extends BaseContractController {
    static $inject = ["$scope", "$q", "$window", "$interval", "$location", "$anchorScroll", "$timeout",
        "simpleCache", "entityService", "contractService",
        "contractSharedDataService", "localCacheService", "notifyService", "eventService", "usageService", "adminService", "assetService", "aclService", "searchService"
    ];

    contractID: string;
    visibility: number;
    initialized: boolean;
    loadingAssets: boolean;                                                 // flag for loading indicator
    usageTemplates: { [key: number]: Models.ICharacteristicTemplate[] };    // dictionary of usage templates per asset
    amountTemplates: { [key: number]: Models.ICharacteristicTemplate[] };   // dictionary of amount templates per usage
    //selectedSearchAssets: { [key: number]: boolean };                       // dictionary of selected assets from asset search modal
    selectedSearchAssetIDs: number[];                                       // recIDs for selected assets from asset search modal
    firstAmountCMDs: { [key: string]: Models.ICharacteristicMetaData[] };   // dictionary of first amount CMDs for amount display 
    editAssetModalParentCurrencyCharData: Models.ICharDataValue;

    editAssetCharDataCollection: Models.ICharDataCollection;                // chardata for editing usages/amounts under assets
    editAssetModalOpen: boolean;                                            // modal for editing usages/amounts under assets
    editAssetModalTitle: string;                                            // modal title for editing usages/amounts under assets
    editAssetModalMode: string;                                             // switches save button mode on edit usage/amount modal
    editAssetModalParentID: string;

    assetRecIDHashList: string[];
    selectedAmounts: Models.IAmountRelationshipPair[];
    selectedAmountCurrencyIDs: number[];
    selectedAmountTemplates: Models.ICharacteristicTemplate[];
    associateAmountsModalOpen: boolean;
    associateInvoiceTemplates: Models.ICharacteristicTemplate[];
    associatedInvoices: Models.IEntity[];
    assetSearchModalOpen: boolean;                                          // open flag for asset search modal
    hasCmds: { [key: string]: boolean };
    locked: boolean;
    forceRefresh: boolean;
    templateGroupIDs: number[];

    contractCurrencyCharData: Models.ICharDataValue;
    usageCurrencyCharDatas: { [usageID: number]: Models.ICharDataValue };
    amountCurrencyCharDatas: { [usageID: number]: Models.ICharDataValue };

    selectedUsage: Models.IUsageRelationshipPair;
    contractUsages: Models.PagedEntities<Models.IUsageRelationshipPair>;
    contractUsageTemplates: Models.ICharacteristicTemplate[];

    headerCollapsed: { [headerID: string]: boolean };
    assetTemplateIDs: { [assetID: string]: number[] };
    templateNames: { [templateID: number]: string };

    canEdit: boolean;

    contractAssets: Models.IRecordRelationshipPairChild[];
    contractAssetChildCounts: { [key: number]: number };
    searchPage: number;
    searchPageSize: number;
    searchPageCount: number;
    searchNumFound: number;
    contractRecID: number;

    parentCharTypeID: number;
    childChartypeID: number;
    parentTemplateID: number;
    showColumns: string[];
    canCreate: boolean;
    allowMultiple: boolean;
    showAdvance: boolean;
    selectedRecIdTitlePairs: Models.IKeyValuePair<number, string>[];
    removeCatalogItemModalOpen: boolean;
    removingCatalogItem: Models.IContractAssetRelationshipPair;
    relatedCatalogItemTitles: string[];
    contractEntityTitle: string;
    deleteCatalogItemListText: string;

    constructor($scope: ng.IScope,
        $q: ng.IQService,
        private $window: ng.IWindowService,
        $interval: ng.IIntervalService,
        public $location: ng.ILocationService,
        public $anchorScroll: ng.IAnchorScrollService,
        private $timeout: ng.ITimeoutService,
        private simpleCache: ng.ICacheObject,
        entityService: EntityService,
        private contractService: ContractService,
        sharedData: ContractSharedDataService,
        localStorage: LocalCacheService,
        notifyService: NotifyService,
        private eventService: EventService,
        private usageService: UsageService,
        adminService: AdminService,
        private assetService: AssetService,
        private aclService: AclService,
        public searchService: SearchService
    ) {

        super($scope, entityService, sharedData, localStorage, notifyService, adminService, $interval, $q, $location, $anchorScroll);

        this.contractID = "";
        this.visibility = 1;
        this.initialized = false;
        this.loadingAssets = true;
        this.usageTemplates = {};
        this.amountTemplates = {};
        //this.selectedSearchAssets = {};
        this.selectedSearchAssetIDs = [];
        this.firstAmountCMDs = {};
        this.forceRefresh = false;

        this.editAssetCharDataCollection = null;
        this.editAssetModalOpen = false;
        this.editAssetModalTitle = "";
        this.editAssetModalMode = "";
        this.editAssetModalParentID = "";

        this.editAssetModalParentCurrencyCharData = null;
        this.assetRecIDHashList = [];
        this.selectedAmounts = [];
        this.selectedAmountCurrencyIDs = [];
        this.selectedAmountTemplates = [];
        this.associateAmountsModalOpen = false;
        this.associateInvoiceTemplates = [];
        this.associatedInvoices = [];
        this.assetSearchModalOpen = false;
        this.hasCmds = {};
        this.locked = false;
        this.templateGroupIDs = [Consts.TemplateGroupIDs.IntellectualPropertyTemplateGroup];
        this.contractCurrencyCharData = null;
        this.usageCurrencyCharDatas = {};
        this.amountCurrencyCharDatas = {};

        this.selectedUsage = null;
        this.contractUsageTemplates = [];

        this.headerCollapsed = {};
        this.assetTemplateIDs = {};
        this.templateNames = {};

        this.canEdit = false;

        this.contractAssets = [];
        this.searchPage = 1;
        this.searchPageSize = 10;
        this.searchPageCount = 1;
        this.searchNumFound = 0;

        this.parentCharTypeID = Consts.CharTypeIDs.transaction;
        this.parentTemplateID = 0;
        this.childChartypeID = Consts.CharTypeIDs.property;
        this.showColumns = [];
        this.canCreate = false;
        this.allowMultiple = false;
        this.showAdvance = true;
        this.selectedRecIdTitlePairs = [];
        this.removeCatalogItemModalOpen = false;
        this.relatedCatalogItemTitles = [];

        $scope.$watch(() => this.sharedData.contract != null ? this.sharedData.contract.charDataCollection.charDatas : null, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.contractCurrencyCharData = Utils.CharUtil.GetCurrencyCharData(this.sharedData.contract.charDataCollection);
            }
        }, true);

        $scope.$watch(
            () => this.sharedData.contract != null ? this.sharedData.contract.charDataCollection.status.lockIndicator : 1,
            (newValue, oldValue) => {
                this.locked = newValue > 0;
            });

        $scope.$watch(() => this.searchPage, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.RefreshAssets();
            }
        });

        $scope.$watch(() => this.searchPageSize, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.RefreshAssets();
            }
        });

        $scope.$watch(() => this.progressStatus, (newValue, oldValue) => {
            if (newValue == "Done") {
                this.RefreshAssets()
                    .then(() => {
                        this.showJobProgressStatus = false;
                    });
            }
        });

        eventService.on(Consts.Events.ContractRefreshAll, () => {
            if (this.initialized) {
                return this.RefreshAll();
            }
        });

    }

    Init(contractID: string, canEdit: string) {
        this.contractID = contractID;

        this.RefreshAssets();
        this.sharedData.RefreshContract(this.contractID).then(() => {
            this.parentTemplateID = this.sharedData.contract.record.templateID;
            this.entityService.getAssociatedTemplatesForTemplate(Consts.CharTypeIDs.transaction, this.sharedData.contract.record.templateID, Consts.CharTypeIDs.usage)
                .then((templates) => {
                    this.contractUsageTemplates = templates.filter(t => t.templateGroupID == Consts.TemplateGroupIDs.UsageModuleLevel);
                });

            //Get ACLs for user
            var targetACL = this.sharedData.contract.charDataCollection.templateMetaData.template.acl;
            this.canEdit = Utils.AclUtil.hasWriteAccess(this.aclService.acls, targetACL);
        });
    }


    /*
     * Refresh Assets section of contract summary
     */
    RefreshAssets(): ng.IPromise<any> {
        this.notifyService.startProgress();
        this.loadingAssets = true;

        var promise1 = this.sharedData.RefreshAssets(this.contractID);

        var promise2 = this.assetService.searchEntityAssets(this.contractID, null, this.searchPage, this.searchPageSize)
            .then((result) => {
                this.contractAssets = [];
                this.contractAssets = result.assets;
                this.contractAssetChildCounts = result.assetChildCounts;
                this.searchNumFound = result.numFound;
                this.searchPageCount = Math.ceil(this.searchNumFound / this.searchPageSize) || 1;
                this.initialized = true;
            });

        return this.$q.all([promise1, promise2])
            .then(() => {
                this.loadingAssets = false;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    RefreshValidation() {
        return this.eventService.call(Consts.Events.ValidateEntity);
    }

    //todo - think this is useless now that we moved it inside a deal controller
    ShowRefresh(): boolean {
        var charTypeID = Utils.IdBuilder.splitEntityID(this.contractID).charTypeID;

        if (charTypeID == Consts.CharTypeIDs.transaction) {
            return true;
        }
        else {
            return false;
        }
    }

    RefreshEntity() {
        this.notifyService.startProgress();
        this.entityService.syncDealCatalogRightsRels(this.contractID)
            .then((result) => {
                this.notifyService.notifySuccess("Catalog Hierarchies Synced");
                this.RefreshAssets()
                    .then(() => {
                        this.notifyService.endProgress();
                    });
            });
    }

    CountVisibleChars(charDataCollection: Models.ICharDataCollection): number {
        if (charDataCollection != null) {
            return Utils.AclUtil.filterCMDsByRights(this.aclService.acls, charDataCollection.templateMetaData, Consts.AccessRight.Read).length;
            //return _(charDataCollection.templateMetaData.characteristicMetaDatas).filter((cmd) => cmd.visibilityIndicator >= this.visibility).valueOf().length;
        }
        return 0;
    }

    /*
     * Gets and caches associable child templates, especially for the nested Asset/usage/amount data
     * @param parentCharTypeID charTypeID of parent entity
     * @param parentTempalteID templateID of the parent entity
     * @param childCharTypeID charTypeID of child entity
     */
    GetAssociatedTemplates(parentCharTypeID: number, parentTemplateID: number, childCharTypeID: number) {
        var deferred = this.$q.defer<Models.ICharacteristicTemplate[]>();
        // make a unique hash
        var key = "pc" + parentCharTypeID + "pt" + parentTemplateID + "cc" + childCharTypeID;
        // make a flag to prevent parallel requests
        var busyKey = key + "busy";
        var output = this.simpleCache.get<Models.ICharacteristicTemplate[]>(key);
        var busy = this.simpleCache.get(busyKey);
        if (output == null && busy == null) {
            this.simpleCache.put(busyKey, true);
            this.entityService.getAssociatedTemplatesForTemplate(parentCharTypeID, parentTemplateID, childCharTypeID)
                .then((result) => {
                    output = result.filter(ct => Utils.AclUtil.hasCreateAccess(this.aclService.acls, ct.acl));
                    this.simpleCache.put(key, output);
                    deferred.resolve(output);
                });
        } else if (output != null) {
            deferred.resolve(output);
        } else {
            deferred.reject();
        }
        return deferred.promise;
    }

    /*
     * Opens AssetSearch modal
     */
    SearchAssets() {
        this.assetSearchModalOpen = true;
        this.allowMultiple = true;
        this.showAdvance = true;
        this.selectedRecIdTitlePairs = [];
    }

    /*
     * Associate selected Assets from Asset Search Modal
     */
    AddAssets() {
        // get selected ids

        var assetIDs: number[] = [];

        if (this.selectedRecIdTitlePairs.length > 0) {
            this.selectedRecIdTitlePairs.forEach((item) => {
                assetIDs.push(item.key);
            });
        }

        if (assetIDs.length > 0) {
            // start progress bar
            this.notifyService.startProgress();
            this.progressStatus = "";
            // make rest call
            this.contractService.addContractAssets(this.contractID, assetIDs)
                .then((result) => {
                    this.progressJobID = result.jobID;
                    this.jobTitle = result.jobTitle;
                    this.showJobProgressStatus = true;
                    this.assetSearchModalOpen = false;
                    this.selectedRecIdTitlePairs = [];
                })
                .finally(() => {
                    // end progress bar
                    this.notifyService.endProgress();
                });
        } else {
            // notify no selected assets
            this.notifyService.notifyError("No Catalog Items were selected");
        }
    }

    ShowRemoveAsset(asset: Models.IContractAssetRelationshipPair) {
        var contractRecID = Utils.IdBuilder.splitEntityID(this.contractID).recID;
         //Does the asset have any invoices for the deal?
        //Get the invoices for the deal
        this.removingCatalogItem = asset;
        this.entityService.getExistingCatalogItemsFromDealToInvoices(contractRecID, [this.removingCatalogItem.record.recordID])
            .then((result) => {
                var breakDelete: boolean = false;

                if (result.success) {
                    breakDelete = _.any(result.data, r => r == this.removingCatalogItem.record.recordID);
                }
                else {
                    breakDelete = true;
                }

                if (breakDelete) {
                    this.$window.alert("Unable to delete this catalog item because there are one or more associated accounting records.");
                    this.notifyService.endProgress();
                    this.$scope.$broadcast(Consts.Events.NotifyDone);
                    this.removingCatalogItem = undefined;
                }
                else {
                    this.removingCatalogItem = asset;
                    var assetTitle = asset.record.title;
                    this.contractEntityTitle = this.sharedData.contract.record.title;
                    this.deleteCatalogItemListText = assetTitle + " and related Catalog Items will be removed from any Rights, Tables and Amounts on this Deal.<br/> Are you sure you want to remove this association?"
                    this.removeCatalogItemModalOpen = true;
                }
            });
    }

    /*
     * Remove an asset from the contract
     * @param asset the entity+chardata+relationship of the asset to be removed
     */
    RemoveAsset() {
        // start progress bar
        this.notifyService.startProgress();
        this.contractService.removeContractAsset(this.contractID, this.removingCatalogItem.relationship.relRecID)
            .then((result) => {
                // notify success
                this.eventService.call(Consts.Events.RefreshTables);
                this.notifyService.notifySuccess("Catalog Item Removed");
                this.contractEntityTitle = "";
                this.deleteCatalogItemListText = "";
                this.removeCatalogItemModalOpen = false;
                // wait for refresh of assets
                return this.RefreshAssets();
            })
            .then(() => {
                this.sharedData.RefreshAssets(this.contractID).then(() => {
                    this.RefreshValidation();
                });
            })
            .finally(() => {
                // end progress bar
                this.notifyService.endProgress();
                this.removeCatalogItemModalOpen = false;
                this.$scope.$broadcast(Consts.Events.NotifyDone);
            });
    }

    AssociateToContract() {
        var contractRecID = Utils.IdBuilder.splitEntityID(this.contractID).recID;
        var amountTemplateIDs = this.selectedAmountTemplates.map((template) => template.templateID);

        var uniqueCurrencySymbols = _.uniq(this.selectedAmountCurrencyIDs);
        if (uniqueCurrencySymbols.length > 1) {
            this.$window.alert("Unable to associate amounts of different currencies to a single document.");
            return;
        }
        this.notifyService.startProgress();
        this.contractService.getAssociableInvoices(contractRecID, amountTemplateIDs, _.first(uniqueCurrencySymbols))
            .then(
                (result) => {
                    this.associatedInvoices = result.invoices;
                    this.associateInvoiceTemplates = result.templates;
                    this.associateAmountsModalOpen = true;
                },
                () => {
                    this.notifyService.notifyError("Error getting invoice information");
                })
            .then(() => {
                this.RefreshValidation();
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    AssocToInvoice(invoice: Models.IEntity, $event: ng.IAngularEvent) {
        $event.preventDefault();
        var amountIds = this.selectedAmounts.map((amount) => amount.record.recordID);
        this.notifyService.startProgress();
        this.contractService.associateAmountsToInvoice(invoice.recordID, amountIds)
            .then(() => {
                this.notifyService.notifySuccess("Amounts associated");
                return this.RefreshAssets();
            }, () => {
                this.notifyService.notifyError("Error associating Amounts");
                return this.$q.reject();
            })
            .then(() => {
                this.associateAmountsModalOpen = false;
                this.RefreshValidation();
            },
                angular.noop)
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    AssocToNewInvoice(template: Models.ICharacteristicTemplate, $event: ng.IAngularEvent) {
        $event.preventDefault();
        var amountIds = this.selectedAmounts.map((amount) => amount.record.recordID);
        var contractRecID = Utils.IdBuilder.splitEntityID(this.contractID).recID;
        this.notifyService.startProgress();
        this.contractService.associateAmountsToNewInvoice(contractRecID, template.templateID, amountIds)
            .then((result) => {
                if (result.success) {
                    this.$window.open("/Go/" + result.entityID, '_blank');
                } else {
                    this.notifyService.notifyError("Error associating Invoice");
                }
            })
            .finally(() => {
                this.RefreshAll();
                this.associateAmountsModalOpen = false;
                this.notifyService.endProgress();
            });
    }

    //RecalculateRates() {
    //    this.notifyService.startProgress();
    //    this.contractService.recalculateRates(this.contractID)
    //        .then(() => {
    //            this.notifyService.notifySuccess("Rates recalculated.");
    //            return this.RefreshAssets();
    //        }, () => {
    //            this.notifyService.notifyError("Error recalculating rates.");
    //            return this.$q.reject();
    //        })
    //        .finally(() => {
    //            this.notifyService.endProgress();
    //        });
    //}

    ToggleOpen(headerID: string) {
        this.headerCollapsed[headerID] = !(!!(this.headerCollapsed[headerID]));
    }

    Delete() {
        if (this.$window.confirm("Are you sure you want to delete this Deal?") && this.$window.confirm("Are you REALLY SURE you want to delete this Deal?")) {
            this.notifyService.startProgress();
            this.contractService.deleteContract(this.contractID)
                .then(() => {
                    this.$window.location.assign(Consts.Urls.ContractListPage);
                },
                    () => {
                        this.notifyService.notifyError("Error Deleting Deal");
                    })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        } else {
            this.$scope.$broadcast(Consts.Events.NotifyDone);
        }
    }

    GetRelationshipID(relationship: Models.IEntityRelationship) {
        return Utils.IdBuilder.buildRelationshipID(relationship);
    }

    RefreshAll(): ng.IPromise<any> {
        var promises = [];
        promises.push(this.RefreshAssets());
        promises.push(this.sharedData.RefreshContract(this.contractID));
        promises.push(this.RefreshValidation());

        return this.$q.all(promises);
    }
}
